<template>
  <div class="ma-2 app">
    <DiscarRamal
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarRamal'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
    />

    <DiscarTronco
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarTronco'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
    />

    <TocarUra
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\TocarUra'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <TocarSinalDeOcupado
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\TocarSinalDeOcupado'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <TocarAudio
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\TocarAudio'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <ValidarSenha
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\ValidarSenha'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <AtivarRegex
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\ChangeToTrueActiveRegex'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <DesativarRegex
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\ChangeToFalseActiveRegex'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <DiscarGrupoAtendimento
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarGrupo'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <DiscarFila
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarFila'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <DiscarOperador
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarAgente'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />

    <ExecutarWebhook
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\ExecutaWebHooks'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />
    <DiscarConferencia
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarConferencia'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />
    <SelecionarMusicaEmEspera
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\SetarMusicaEspera'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />
    <DiscarAvaliacaoAtendimento
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\DiscarPesquisa'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />
    <SetarPesquisaAtendimento
      v-if="acao.acao.class === 'Modules\\Agi\\Entities\\acoes\\SetarPesquisa'"
      :acao="acao"
      @form="update($event)"
      @error="error($event)"
      class="align-content-end"
    />
  </div>
</template>

<script>
import DiscarRamal from './DiscarRamal'
import DiscarTronco from './DiscarTronco'
import TocarUra from './TocarUra'
import TocarSinalDeOcupado from './TocarSinalDeOcupado'
import TocarAudio from './TocarAudio'
import ValidarSenha from './ValidarSenha'
import AtivarRegex from './AtivarRegex'
import DesativarRegex from './DesativarRegex'
import DiscarGrupoAtendimento from './DiscarGrupoAtendimento'
import DiscarFila from './DiscarFila'
import DiscarOperador from './DiscarOperador'
import ExecutarWebhook from './ExecutarWebhook'
import DiscarConferencia from './DiscarConferencia'
import SelecionarMusicaEmEspera from './SelecionarMusicaEmEspera'
import DiscarAvaliacaoAtendimento from './DiscarAvaliacaoAtendimento'
import SetarPesquisaAtendimento from './SetarPesquisaAtendimento'

export default {
  name: 'Dialog',
  props: {
    acao: Object,
  },
  components: {
    DiscarRamal,
    DiscarTronco,
    DiscarFila,
    TocarUra,
    TocarSinalDeOcupado,
    TocarAudio,
    ValidarSenha,
    AtivarRegex,
    DesativarRegex,
    DiscarGrupoAtendimento,
    DiscarOperador,
    ExecutarWebhook,
    DiscarConferencia,
    SelecionarMusicaEmEspera,
    DiscarAvaliacaoAtendimento,
    SetarPesquisaAtendimento,
  },

  data: () => ({
    dialog: true,
    componentKey: 0,
  }),
  methods: {
    update(event) {
      this.$emit('form', event)
    },
    error(error) {
      this.$emit('error', error)
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
